module.exports = __webpack_public_path__ + "img/tooltip-energy.8529afdd.png";